<template>
  <div class="mt-2">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div class="table-wrapper">
      <b-table
        :busy="isLoading"
        head-variant="light"
        :no-local-sorting="true"
        :items="items"
        :fields="getAllFields"
        :current-page="currentPage"
        per-page="0"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :sticky-header="height"
        no-border-collapse
        responsive
        show-empty
        small
        @sort-changed="sortingChanged"
      >
        <template #table-busy>
          <table-skeleton />
        </template>
        <template #empty>
          <template v-if="newPolicyBtn">
            <div
              class="d-flex flex-column justify-content-center align-items-center my-3"
              style="max-width: max-content; margin-inline: auto"
            >
              <p class="mb-2">
                Effettua una ricerca oppure, se non trovi risultati, crea una
                nuova Polizza cliccando sul pulsante qui sotto
              </p>
              <b-button
                class="btn-create"
                type="button"
                variant="primary"
                size="sm"
                @click="onAddNewPolicy"
                title="Crea"
                :disabled="!canVerb(resource, 'store')"
                style="max-width: max-content"
              >
                <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                Crea
              </b-button
              >
            </div>
          </template>
          <template v-else>
            <empty-table
              :isTableInModal="isTableInModal"
              :performedSearch="performedSearch"
              :automaticPerformedSearch="automaticPerformedSearch"
              :filterCount="filterCount"
            />
          </template>
        </template>
        <template #cell(contraente)="{ item }" v-if="items.length">
          <span v-html="toInfoData(item.registry, 'registryfullname')"></span>
        </template>
        <template #cell(delay_days)="{ item }" v-if="items.length">
          <span v-html="computeDelayDays(item)"></span>
        </template>
        <template #cell(compagnia)="{ item }" v-if="items.length">
          {{
            item.insurer ? `${item.insurer.code}-${item.insurer.title}` : ""
          }}
        </template>
        <template #cell(branch_risk)="{ item }" v-if="items.length">
          {{
            item.insurance_risk
              ? `${item.insurance_risk.risk_branch.code}-${item.insurance_risk.code}-${item.insurance_risk.formatted_title}`
              : ""
          }}
        </template>
        <template v-slot:[riskBranchTitle]="row">
          <!-- Ramo -->
          <template
            v-if="
                row.item.insurance_risk &&
                Object.prototype.hasOwnProperty.call(
                  row.item,
                  'insurance_risk'
                ) &&
                Object.prototype.hasOwnProperty.call(
                  row.item.insurance_risk,
                  'risk_branch'
                )
              "
          >
            {{
              row.item?.insurance_risk?.risk_branch?.code
                ? `${row.item.insurance_risk.risk_branch.code}-`
                : ""
            }}{{ row.item.insurance_risk.risk_branch.title }}
          </template>
          <template v-else>-</template>
        </template>
        <template #cell(insurance_risk)="{ item }" v-if="items.length">
          <!-- Rischio -->
          <span
            v-if="
                item.insurance_risk &&
                Object.prototype.hasOwnProperty.call(item, 'insurance_risk')
              "
          >
            {{
              item?.insurance_risk?.code
                ? `${item.insurance_risk.code}-`
                : ""
            }}{{ getRiskTypeDescription(item) }}
          </span>
          <template v-else>-</template>
        </template>
        <template #cell(broker)="{ item }" v-if="items.length">
          <b-row class="broker-cell"
            ><span v-html="toInfoData(item.broker, 'broker', 0)"></span>
            <div class="action-buttons" v-if="actions.includes('edit_broker')">
              <b-button
                size="sm"
                variant="lisaweb"
                @click="openEditBrokerModal(item)"
                class="mt-1 ml-3"
                title="Modifica Produttore"
                :disabled="isImportedPolicy(item)"
              >
                <base-icon name="edit" width="22"></base-icon>
              </b-button>
            </div>
          </b-row>
        </template>
        <template #cell(collaborator)="{ item }" v-if="items.length">
          <span v-html="toInfoData(item.collaborator, 'broker', 1)"></span>
        </template>
        <template #cell(note_counter)="row" v-if="items.length">
          <div
            role="button"
            class="info-box float-left"
            @click="customOpenNoteModal(row.item, row.index, $event.target)"
            v-b-tooltip="
                toTooltipTask(
                  row.item.tasks.filter((task) => task.task_type.value === 2),
                  'Note',
                  [
                    { label: 'Titolo', key: 'title' },
                    { label: 'Descrizione', key: 'description' },
                    {
                      label: 'Ultimo aggiornamento',
                      key: 'last_update',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                    {
                      label: 'Creato da',
                      key: 'owner_id',
                      formatter: (val) => retriveOwner(val),
                    },
                    {
                      label: 'Data creazione',
                      key: 'created_at',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                  ]
                )
              "
          >
            {{
              row.item.tasks.filter((task) => task.task_type.value === 2)
                .length
            }}
          </div>
        </template>
        <template #cell(document_counter)="row" v-if="items.length">
          <!-- <template #cell(document_counter)="{ item }" v-if="items.length"> -->
          <div
            role="button"
            class="info-box float-left"
            @click="customOpenDocModal(row.item, row.index, $event.target)"
            v-b-tooltip="
                toTooltipTask(row.item.documents, 'Documenti', [
                  { label: 'Titolo', key: 'title' },
                  { label: 'Descrizione', key: 'note' },
                  {
                    label: 'Ultimo aggiornamento',
                    key: 'last_update',
                    formatter: (val) => {
                      return moment(val).format('DD/MM/YYYY HH:mm:ss');
                    },
                  },
                ])
              "
          >
            {{ row.item.documents.length }}
          </div>
        </template>
        <template
          #cell(gross_payment_splitting)="{ item }"
          v-if="items.length"
        >
          {{ toLocaleCurrency(splittingGrossPremium(item)) }}
        </template>
        <template #cell(primary_group)="{ item }" v-if="items.length">
          {{
            item.registry
              ? item.registry.registry_groups.length && item.registry.registry_groups.find(
                registry_group => registry_group.pivot.primary.value === 'Y'
              ) ? item.registry.registry_groups.find(
                registry_group => registry_group.pivot.primary.value === 'Y'
              ).code : ""
              : "",
          }}
        </template>
        <template #cell(actions)="row">
          <div class="action-buttons">
            <b-button
              v-if="actions.includes('infomodal')"
              size="sm"
              variant="lisaweb"
              @click="openModal(row.item, row.index, $event.target)"
              class="mt-1 mr-1"
              title="Modale Dettagli"
            >
              <!-- <base-icon name="eye" width="22"></base-icon> -->
              <base-icon name="eye" width="22"></base-icon>
            </b-button>
            <b-button
              v-if="actions.includes('details')"
              size="sm"
              variant="lisaweb"
              @click="row.toggleDetails"
              class="mt-1 mr-1"
              :title="
                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'
                "
            >
              <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>
              <b-icon v-else icon="chevron-down"></b-icon>
            </b-button>
            <b-button
              v-if="actions.includes('edit')"
              size="sm"
              variant="lisaweb"
              @click="onEdit(row.item.id, row.item)"
              class="mt-1 mr-1"
              title="Modifica"
            >
              <!-- <base-icon name="edit" width="22"></base-icon> -->
              <base-icon name="edit" width="22"></base-icon>
            </b-button>
            <b-button
              v-if="actions.includes('destroy')"
              size="sm"
              variant="lisaweb"
              @click="onDestroy(row.item.id)"
              class="mt-1 mr-1"
              title="Elimina"
            >
              <base-icon name="trash" width="22" height="22"></base-icon>
            </b-button>
          </div>
        </template>
        <template #cell(rowSelector)="row">
          <div class="action-buttons">
            <b-button
              size="sm"
              variant="lisaweb"
              @click="onChosen(row.item)"
              class="mt-1 mr-1"
              title="Seleziona"
            >
              <b-icon icon="hand-index-thumb" aria-hidden="true"></b-icon>
            </b-button>
          </div>
        </template>
        <template
          slot="bottom-row"
          slot-scope="data"
          v-if="includeBottomRow && items.length"
        >
          <td
            v-for="(field, i) in data.fields"
            :key="i"
            :class="`totalRow${
                i !== 0 && evaluateTdClass(field.key) ? ' text-right' : ''
              }`"
          >
            <b
            >{{ i === 0 ? "Totale: " : "" }}
              {{
                i !== 0 && field.key === "gross_premium"
                  ? toLocaleCurrency(fieldSum(items, "gross_premium"))
                  : null
              }}
              {{
                i !== 0 && field.key === "gross_payment_splitting"
                  ? toLocaleCurrency(
                    fieldSum(
                      items.map((item) => {
                        return {
                          gross_premium_splitting:
                            splittingGrossPremium(item),
                        };
                      }),
                      "gross_premium_splitting"
                    )
                  )
                  : null
              }}
            </b>
          </td>
        </template>
        <template #row-details="row">
          <b-card>
            <b-row
              class="mb-2"
              v-for="(value, key) in customized(row.item)"
              :key="key"
            >
              <b-col sm="3" class="text-sm-right"
              ><b>{{ key | capitalize }}:</b></b-col
              >
              <b-col>{{ value }}</b-col>
            </b-row>
          </b-card>
        </template>
        <template v-slot:[`cell(status_policy.text)`]="{ item }">
          <status-badge kind="policy" :status="item.status_policy" />
        </template>
        <template #cell()="{ value }">
          <span>{{ value }}</span>
        </template>
      </b-table>
    </div>
    <pagination-skeleton v-if="isLoading && !noPagination" />
    <div
      class="pagination-wrapper"
      v-if="!isLoading && !noPagination && items.length"
    >
      <div class="info">
        <div class="show-text">
          <p>
            <label for="per-page-select-registry"
            >Numero di risultati per pagina:</label
            >
          </p>
        </div>
        <div class="group">
          <b-form-group label-for="per-page-select">
            <b-form-select
              id="per-page-select-registry"
              v-model="perPage"
              :options="pageOptions"
              style="width: 68px"
              size="sm"
              @change="onPageChange(1)"
              :disabled="!items.length"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="page">
          <p>
            Risultati da
            <strong>{{ formatItemsFrom }}</strong> a
            <strong>{{ formatItemsTo }}</strong> su un totale di
            <strong>{{ formatTotalItems }}</strong>
          </p>
        </div>
      </div>
      <div class="info-action">
        <div class="pagination" v-if="totalItems">
          <b-pagination
            v-model="currentPage"
            limit="3"
            :total-rows="totalItems"
            :per-page="perPage"
            size="sm"
            @change="onPageChange"
          >
            <template #page="{ page, active }">
                <span :data-active="active">{{
                    page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }}</span>
            </template>
            <template v-slot:first-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
            </template>
            <template v-slot:prev-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
            </template>
            <template v-slot:next-text>
                <span
                ><base-icon
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
            </template>
            <template v-slot:last-text>
                <span
                ><base-icon
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
            </template>
          </b-pagination>
        </div>
        <div
          class="input_pagination"
          v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
        >
          <base-input-pagination
            @pagination="onInputPagination"
          ></base-input-pagination>
        </div>
      </div>
    </div>
    <b-modal
      :id="infomodalName"
      @show="onModalShow"
      @hidden="onModalHidden"
      :title="modalTitle"
      size="xl"
      scrollable
      ok-only
      ok-title="Chiudi"
      ok-variant="-transparent"
      header-bg-variant="lisaweb"
      no-close-on-backdrop
    >
      <template v-slot:modal-header-close>
        <base-icon name="close" width="14" height="14"/>
      </template>
      <div>
        <b-tabs content-class="" lazy v-model="tabIndex">
          <b-tab
            v-for="(tab, index) in tabs"
            :active="index === tabIndex"
            :key="index"
            :title="tab.text"
            @click="setTab(tab, index)"
            title-item-class="lisaweb"
          >
            <button-group-tab></button-group-tab>
            <keep-alive>
              <component
                v-if="selected === tab.name"
                :is="selected"
                :resourceId="modalResourceId"
                :dbRowData="dbRowData"
                @fetch="fetch"
              ></component>
            </keep-alive>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
    <edit-policy-broker-modal
      ref="editPolicyBrokerModal"
      @updated="fetch"
    ></edit-policy-broker-modal>
  </div>
</template>

<script>
import template from "./template";
import StatusBadge from "@/components/StatusBadge";
import BaseIcon from "@/components/BaseIcon";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import BaseInputPagination from "@/components/form/BaseInputPagination";
import General from "@/components/wallet/policies/details/General";
import TechnicalData from "@/components/wallet/policies/details/TechnicalData";
import Registry from "@/components/wallet/policies/details/Registry";
import Group from "@/components/wallet/policies/details/Group";
import Titles from "@/components/wallet/policies/details/Titles";
import Accident from "@/components/wallet/policies/details/Claims";
import Notes from "@/components/wallet/policies/details/Notes";
import Todo from "@/components/wallet/policies/details/Todo";
import Accounting from "@/components/wallet/policies/details/Accounting";
import Appointments from "@/components/wallet/policies/details/Appointments";
import Documents from "@/components/wallet/policies/details/Documents";
import Sepa from "@/components/wallet/policies/details/Sepa";
import {toLocaleCurrency} from "@/utils/strings";
import {sumBreakdowns} from "@/utils/breakdowns";
import {getRiskTypeDescription, getVirtualValue} from "@/utils/payments";
import {canModule} from "@/utils/permissions";
import {mapGetters} from "vuex";
import EmptyTable from "@/components/EmptyTable.vue";
import EditPolicyBrokerModal from "@/components/modals/editPolicyBrokerModal.vue";


import moment from "moment";

moment.locale("it");

export default {
  name: "PoliciesTable",
  extends: template,
  data() {
    return {
      tabs: [
        {name: "General", text: "Generale"},
        {name: "TechnicalData", text: "Dati tecnici"},
        {name: "Registry", text: "Contraente"},
        {name: "Titles", text: "Titoli"},
        {name: "Accounting", text: "Incassi"},
        {name: "Accident", text: "Sinistri"},
        {name: "Appointments", text: "Appuntamenti"},
        {name: "Notes", text: "Note"},
        {name: "Todo", text: "Attività"},
        {name: "Group", text: "Gruppi"},
        {name: "Documents", text: "Doc"},
      ],
      selected: "General",
      modalResourceId: null,
      dbRowData: null, // tab Contraente deve avere i dati della polizza per Voltura
      tabIndex: 0,
      risk_branch_title: "insurance_risk.risk_branch.title",
    };
  },
  props: {
    parentResourceId: {
      type: Number,
    },
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    newPolicyBtn: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    StatusBadge,
    BaseIcon,
    BaseInputPagination,
    General,
    TechnicalData,
    Registry,
    Group,
    Titles,
    Accident,
    Notes,
    Accounting,
    Documents,
    Appointments,
    ButtonGroupTab,
    Todo,
    Sepa,
    EmptyTable,
    EditPolicyBrokerModal,
  },
  methods: {
    canModule,
    toLocaleCurrency,
    sumBreakdowns,
    getVirtualValue,
    getRiskTypeDescription,
    isImportedPolicy(item) {
      return item &&
        Object.prototype.hasOwnProperty.call(item, "insurer") &&
        item.insurer &&
        Object.prototype.hasOwnProperty.call(item.insurer, "importer_id") &&
        this.isImported(item);
    },
    isImported(item) {
      let isImported = item.insurer.importer_id !== null;
      if (isImported && item.insurer.import_override === 1) {
        return isImported = false;
      }
      return isImported;
    },
    openEditBrokerModal(item) {
      this.$refs.editPolicyBrokerModal.show(item);
    },
    htmlComputedDelayDays(
      item_delay_days,
      item_insurance_risk_delay_days,
      value
    ) {
      return `<span class="${
        item_delay_days != null &&
        item_insurance_risk_delay_days != null &&
        item_delay_days !== item_insurance_risk_delay_days
          ? "different-delay-days"
          : "same-delay-days"
      }">${value}</span>`;
    },
    computeDelayDays(item) {
      let item_delay_days = null;
      let item_insurance_risk_delay_days = null;
      if (item && Object.prototype.hasOwnProperty.call(item, "delay_days"))
        item_delay_days = item.delay_days;
      if (
        item &&
        Object.prototype.hasOwnProperty.call(item, "insurance_risk") &&
        item.insurance_risk &&
        Object.prototype.hasOwnProperty.call(item.insurance_risk, "delay_days")
      )
        item_insurance_risk_delay_days = item.insurance_risk.delay_days;
      if (item_delay_days != null)
        return this.htmlComputedDelayDays(
          item_delay_days,
          item_insurance_risk_delay_days,
          item_delay_days
        );
      if (item_insurance_risk_delay_days != null)
        return this.htmlComputedDelayDays(
          item_delay_days,
          item_insurance_risk_delay_days,
          item_insurance_risk_delay_days
        );
      return "-";
    },
    onAddNewPolicy() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    evaluateTdClass(key) {
      return ["gross_premium", "gross_payment_splitting"].includes(key);
    },
    retriveOwner(value) {
      if (!value) return "-";
      return (
        this.getUsers().find((user) => user.value === value)?.username ?? "-"
      );
    },
    onModalShow() {
      if (this.tabIndex < this.tabs.length)
        this.setTab(this.tabs[this.tabIndex], this.tabIndex);
    },
    onModalHidden() {
      this.setTab({name: "General", text: "Generale"}, 0);
    },
    // OVERRIDE: c'è il filtro fittizio byTypology
    customOpenNoteModal(item, index, target) {
      this.tabIndex = 7; // TabIndex ID delle Note
      this.openModal(item, index, target);
    },
    customOpenDocModal(item, index, target) {
      this.tabIndex = 10; // TabIndex ID dei Documenti
      this.openModal(item, index, target);
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    keepFilter() {
      // preparo il criterio col filtro fittizio
      // process the byTypology filter -> transform it as byAttribute
      let filter =
        this.$parent.$data.filter || this.$parent.$parent.$data.filter;

      if (
        !filter ||
        (filter.filterInsurancePolicyDetail1 &&
          filter.filterInsurancePolicyDetail2)
      ) {
        return {};
      }
      let byA = filter.byAttribute.status_policy;
      let byT = filter.byTypology.status_policy;
      // NOTA: per spezzare la reattività del "filter" usare JSON.parse(JSON.stringify()) !!!
      // altrimenti criteria.byAttribute.status_policy = byT imposta anche this.filter.byAttribute.status_policy = byT
      // e i v-model delle 2 select vanno a ramengo...
      let name =
        this.$parent.$data.filterName || this.$parent.$parent.$data.filterName;
      let criteria = JSON.parse(JSON.stringify(filter[name] || filter));
      if (byT && !byA) {
        criteria.byAttribute.status_policy = byT;
        criteria.byTypology.status_policy = null;
      }

      this.saveFilterByName({name, criteria});
      return filter;
    },
    customized(item) {
      let c = {};
      c.data_decorrenza = moment(item.effective_at).format("DD/MM/YYYY");
      c.data_scadenza = moment(item.expired_at).format("DD/MM/YYYY");
      c.data_copertura = moment(item.covered_at).format("DD/MM/YYYY");
      c.data_emissione = moment(item.issued_at).format("DD/MM/YYYY");
      let customAttributes = this.convertFromCustomAttributesToFields(
        this.customAttributes()(this.repository)
      );
      Object.keys(customAttributes).forEach((i) => {
        let value = customAttributes[i].key.split(".");
        let label = customAttributes[i].label;
        c[label] = item.attributables[value[value.length - 1]];
      });
      return c;
    },
    fieldSum(items, field) {
      items;
      return items
        .map((item) => item[field])
        .reduce((prev, next) => prev + next, 0);
    },
    splittingGrossPremium(item) {
      return (
        item.gross_premium *
        (12 / (parseInt(item.payment_splitting.value) || 12))
      );
    },
    ...mapGetters("auth", {
      getUsers: "users",
    }),
  },
  computed: {
    isCreateRoutePath() {
      return (
        this.$route.path.indexOf("create") >= 0 &&
        this.$route.path !== "/insurance-ancillaries-create"
      );
    },
    riskBranchTitle() {
      return `cell(${this.risk_branch_title})`;
    },
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  beforeMount() {
    if (canModule("module.PROF.SEPA")) {
      this.tabs.push({name: "Sepa", text: "SEPA"});
    }
  },
};
</script>

<style lang="scss" scoped>
:deep(.different-delay-days) {
  font-weight: bold;
  color: #0600ff;
}
</style>
